import { LayoutDashboard, CreditCard, Settings2, ChartSpline, Sparkles } from "lucide-react"
import { NavItem } from "@/types/nav"

export const accountPayablesNav: NavItem[] = [
  {
    title: "Dashboard",
    url: "/dashboard/account-payables/dashboard/overview",
    icon: LayoutDashboard,
  },
  {
    title: "Payables",
    url: "/dashboard/account-payables/payables",
    icon: CreditCard,
    items: [
      {
        title: "Upcoming",
        url: "/dashboard/account-payables/payables/upcoming",
      },
      {
        title: "Disbursed",
        url: "/dashboard/account-payables/payables/disbursed",
      },
      {
        title: "Flagged",
        url: "/dashboard/account-payables/payables/flagged",
      },
      {
        title: "Resident Funding",
        url: "/dashboard/account-payables/payables/resident-funding",
      },
    ],
  },
  {
    title: "Reports",
    url: "/dashboard/account-payables/reports",
    icon: ChartSpline,
    items: [
      {
        title: "Funding History",
        url: "/dashboard/company/funding-history",
      },
      {
        title: "Fees Absorption",
        url: "/dashboard/account-payables/reports/fees-absorption",
      },
      {
        // The page lives under /dashboard/utility-admin/reports/sla-breach-report
        // (built by feature/sla-breach-report on main). Backend permission
        // gate (IsSLABreachAuthorized) allows account_payables. The URL
        // is exact-path-allowed for account_payables in role-navigation.ts.
        title: "SLA Breach Report",
        url: "/dashboard/utility-admin/reports/sla-breach-report",
      }
    ],
  },
  {
    title: "AI Tools",
    url: "/dashboard/ai-tools",
    icon: Sparkles,
    items: [
      {
        title: "Fee Analyzer",
        url: "/dashboard/ai-tools/fee-analyzer",
      }
    ],
  },
  {
    title: "Settings",
    url: "/dashboard/account-payables/settings",
    icon: Settings2,
    items: [
      {
        title: "Entity Bank Accounts",
        url: "/dashboard/account-payables/settings/bank-accounts",
      },
      {
        title: "Charge Codes",
        url: "/dashboard/account-payables/settings/gl-codes",
      },
      {
        title: "Spike Thresholds",
        url: "/dashboard/account-payables/settings/spike-threshold",
      },
    ],
  }
]
